import { Component } from "@angular/core";

@Component({
	selector: "app-welcome",
	templateUrl: "./welcome.component.html",
	styleUrl: "./welcome.component.scss",
	standalone: false,
})
export class WelcomeComponent {}
